<template>
  <div class="bg-secondary-3">
    <div class="py-1 px-4 rounded">
      <div class="row mt-4">
        <div class="col-9 d-flex">
          <i class="fas fa-undo text-orange mr-2 mt-1"></i>
          <p class="callout-sub-section-title">
            Ver Enmendados
          </p>
        </div>
        <div class="col-3 d-flex justify-content-end">
          <action-button
            type="button"
            text="Cerrar"
            i="fas fa-times-circle"
            variant="outline-danger"
            class="ml-2 px-4 mb-3 actionButton"
            @click="close"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <callout
            v-for="(item, index) in items"
            :key="index"
            border-color-hex="#B5C3BC"
            borderColor="#B5C3BC"
            apply-border-top
            :controlled="true"
            :has-border="true"
            has-gradient
            :has-toggle="false"
            :opened="false"
            :class-main="'bg-white mb-3'"
          >
            <div class="row">
              <div class="col-12 col-md-9">
                <div class="row pt-2">
                  <div class="col-12 col-md-3">
                    <label class="text-gray font-14">Fecha de Enmienda:</label>
                    <p class="font-14 text-description">
                      {{ item.date | date }}
                    </p>
                  </div>
                  <div class="col">
                    <label class="text-gray font-14">Progreso Academico:</label>
                    <p class="font-14 text-description">
                      {{ value(item) }}
                    </p>
                  </div>
                  <div class="col">
                    <label class="text-gray font-14">Fecha de Sometido:</label>
                    <p class="font-14 text-description">
                      {{ item.submittedDate | date }}
                    </p>
                  </div>
                  <div class="col">
                    <label class="text-gray font-14">Fecha de Discusión:</label>
                    <p class="font-14 text-description">
                      {{ item.discussionDate | date }}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">
                    <label class="text-gray font-14">
                      Comentario de la enmienda:
                    </label>
                    <p class="font-14 text-description">{{ item.reason }}</p>
                  </div>
                </div>
              </div>
              <div class="col d-flex align-items-start justify-content-end">
                <div class="p-2">
                  <action-button
                    type="button"
                    text="Ver"
                    i="fas fa-arrow-circle-right"
                    variant="success"
                    class="ml-2 px-4 mb-3 actionButton"
                    @click="view(item)"
                  />
                </div>
              </div>
            </div>
          </callout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import Callout from 'custom-callout';
const EDUCATIONAL_SERVICES_PROGRAM_PAGE = 'educational-services-program';

export default {
  name: 'AcademicProgressViewAmend',
  components: {
    ActionButton,
    Callout,
  },
  props: {
    items: {
      type: Array,
      default: [],
      require: true,
    },
    weekName: {
      type: String,
      default: '',
      require: true,
    },
    item: {
      type: Object,
      default: {},
      require: true,
    },
  },
  computed: {
    value() {
      return (item) => (item.isNt ? 'NT' : this.percentage(item.progress));
    },
    percentage() {
      return (value) => (value === 0 ? '0%' : value ? `${value}%` : '-');
    },
  },
  methods: {
    async view(amend) {
      const params = {
        studentSie: this.item.studentSieId,
        academicYear: this.item.academicYearId,
        week: this.item.week,
        id: amend.id,
        onlyPsc: false,
      };
      this.$router.push({
        name: EDUCATIONAL_SERVICES_PROGRAM_PAGE,
        params,
      });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  font-weight: normal !important;
}
</style>
